<template>
  <!--自定义弹框组件-->
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      @ok="sureSubmit"
      @cancel="cancel"
    >
      <div>
        <a-select
          showSearch
          placeholder="请选择账号类别"
          optionFilterProp="children"
          style="width: 100%"
          @change="handleChangeCategory"
        >
          <a-select-option value="countyAccount">代理帐号</a-select-option>
          <a-select-option value="factoryAccount">厂家账号</a-select-option>
          <a-select-option value="terminalAccount">终端账号</a-select-option>
        </a-select>
        <a-select
          showSearch
          placeholder="请选择账号归属"
          optionFilterProp="children"
          v-if="terminalShow"
          style="width: 100%;margin-top: 20px;"
          :allowClear="true"
          @change="selectUser"
          @search="filterOption"
        >
          <a-select-option
            v-for="(s, index) in countyData"
            :key="index"
            :value="s.objectId"
          >
            {{s.name ? s.name : s.phone}}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { sendMessage } from '@/assets/js/tools'
import moment from 'moment'
export default {
  data () {
    return {
      terminalShow: false, // 账号归属框显示
      countyData: [], // 代理账号数据
      visible: true,
      data: {}
    }
  },
  props: {
    record: Object, // 当前行的数据
    options: Array,
    vm: null, // 使用这个action的模型组件，可能为modelTable或modelTree，与callback中的vm用法保持一致
    title: String,
    modal: String
  },
  mounted () {
    this.getInit()
  },
  methods: {
    moment,
    async getInit () {
      // 获取代理账号用户（10条）
      this.countyData = await this.$modelAjax.getList('_User', {
        params: {
          limit: 10,
          where: {
            accountCategory: 'countyAccount'
          }
        }
      })
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
    /**
    * 选择类别
    * @date: 2020/3/31
    */
    handleChangeCategory (val) {
      this.data = { accountCategory: val }
      this.terminalShow = val === 'terminalAccount'
    },
    /**
    * 根据输入的值筛选
    * @date: 2020/3/31
    */
    async filterOption (input) {
      this.countyData = []
      if (!input) { return }
      this.countyData = await this.$modelAjax.getList('_User', {
        params: {
          limit: 10,
          where: {
            name: {
              $regex: `${input}`
            },
            accountCategory: 'countyAccount'
          }
        }
      })
    },
    /**
    * 选择代理账号
    * @date: 2020/3/31
    */
    selectUser (val) {
      this.data.belongingAccount = val
    },
    /**
    * 开通账号流程.判断时间.编辑用户信息
    * @date: 2020/3/31
    */
    async sureSubmit () {
      try {
        // 判断账号类别是否存在
        if (!this.data.accountCategory) {
          throw this.vm.$notification['error']({
            message: '您未选择账号类别',
            description: '请重新尝试'
          })
        }
        // 判断账号归属是否存在
        if (this.data.accountCategory === 'terminalAccount' && !this.data.belongingAccount) {
          throw this.vm.$notification['error']({
            message: '您未选择账号归属',
            description: '请重新尝试'
          })
        }
        // 判断数据库是否有手机号信息
        let res = await this.$modelAjax.getList('_User', { params: { limit: 1, where: { phone: this.record.phone } } })
        if (res.length > 0) {
          throw this.$notification['error']({
            message: '已有该用户的注册信息',
            description: '请重新尝试'
          })
        }
        // 创建用户信息
        let obj = {
          name: this.record.name,
          phone: this.record.phone,
          accountCategory: this.data.accountCategory,
          belongingAccount: this.data.belongingAccount || null,
          businessType: this.record.businessType,
          storeName: this.record.storeName,
          storeAddress: this.record.storeAddress
        }
        if (this.data.accountCategory === 'countyAccount') { obj.membershipLevel = 'registeredMember' }
        let user = await this.vm.$modelAjax.post('_User', obj)
        // 创建默认收货地址数据
        await this.vm.$modelAjax.post('shippingAddress', {
          name: this.record.name,
          user: user.data.objectId,
          phone: this.record.phone,
          region: this.record.region,
          address: this.record.storeAddress,
          default: 'yes'
        })
        // 修改状态
        await this.vm.$modelAjax.put('applicationRecord', this.record.objectId, { permissionStatus: 'opened' })
      } catch (e) {
        throw this.vm.$notification['error']({
          message: '您授权该账号失败',
          description: '请重新尝试'
        })
      }
      // 短信通知用户授权状态
      await sendMessage([this.record.phone], '恭喜您的账号授权成功了！请打开App登录，感谢您选择我们平台。')
      // 短信通知
      this.vm.$notification['success']({
        message: '您已成功授权该账号登录App',
        description: '权限状态修改成功'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
